module.exports = __webpack_public_path__ + "img/&-about.ae002613.svg";